import React from 'react'

import { Text } from 'styles/reactnative'
import { Input } from 'antd'
import { Meta, MetaTitle, MetaView } from './styles'

const EventInput = ({ value, setValue, name, placeholder }) => {
	return (
		<MetaView>
			<MetaTitle>
				<Text>{name}</Text>
			</MetaTitle>
			<Meta
				style={{
					background: 'transparent',
					padding: 0,
					width: '100%',
				}}>
				<Input
					style={{ width: '100%' }}
					placeholder={placeholder}
					value={value}
					onChange={e => setValue(e.target.value)}
				/>
			</Meta>
		</MetaView>
	)
}

export default EventInput
